<template>
<div id="login-register">
    <div class="width-100">
        <div class="dividend">
            <form @submit="handleSubmit">
                <div class="form-group position-relative">
                    <input v-model="email" class="input-w-icon form-control" type="email" name="email" id="email" placeholder="Email (required)" required tabindex="20" />
                </div>
                <br>
                <div class="form-group">
                    <vue-tel-input :class="`form-control ${isPhoneError && showError ? 'error' : ''}`" defaultCountry="PK" :inputOptions="telInputOptions" validCharactersOnly v-model="mobile" @input="validate" @blur="showError = true" @focus="showError = false" :autoFormat="true" mode="national" invalidMsg="Please enter a valid phone number" tabindex="20"></vue-tel-input>
                </div>
                <p v-if="isPhoneError && showError" id="phone-error" class="text-danger text-500 text-sm m-2">
                    Invalid Phone Number
                </p>

                <br>
                <div class="form-group position-relative">
                    <input v-model="name" class="input-w-icon form-control" type="text" name="name" id="name" placeholder="Name (required)" required tabindex="20" />
                </div>
                <br>
                <div class="form-group position-relative">
                    <input v-model="lastname" class="input-w-icon form-control" type="text" name="lastname" id="name" placeholder="Last Name (required)" required tabindex="20" />
                </div>
                <br>
                <div class="form-group position-relative">
                    <input v-model="city" class="input-w-icon form-control" type="text" name="city" id="name" placeholder="City (required)" required tabindex="20" />
                </div>
                <br>
                <div class="form-group">
                    <v-select v-model="selectedItemGroup" :options="item_group" label="name" :multiple="false" placeholder="Select Item Group (Required)" required :tabindex="20"></v-select>
                </div>
                <br>
                <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                    <b-spinner></b-spinner> Loading...
                </div>
                <div v-if="selectedItemGroup != null" class="form-group">
                    <label v-if="selectedItemGroup != null && items.length > 0" class="text-success ms-5 ps-3">Select courses (required)</label>
                    <div>
                        <b-form-checkbox-group v-model="selectedCourses">
                            <b-form-checkbox v-for="item in items" :key="item.item_name" :value="item"><span class="ms-2">{{ item.item_name }}</span></b-form-checkbox>
                        </b-form-checkbox-group>
                    </div>
                </div>
                <div v-if="selectedItemGroup !=null && items.length == 0 && !loading" class="text-danger text-center">No Items</div>
                <button class="login-register-btn form-control mt-4" id="submit-button" type="submit" :disabled="loading" tabindex="90">
                    <b-spinner v-if="loading" small> </b-spinner>
                    Register
                </button>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import * as LmsApiHelper from '../store/LmsApiHelper';
import "vue-select/dist/vue-select.css";
import {
    mapState
} from 'vuex';
const getCountryISO3 = require("country-iso-2-to-3");
const telInputOptions = {
    autocomplete: "on",
    maxlength: 15,
    tabindex: 15,
    placeholder: "Phone Number (required)",
    mode: "national",
};
export default {
    name: 'StudentForm',
    data() {
        return {
            isPhoneError: false,
            showError: false,
            telInputOptions,
            email: "",
            mobile: "",
            name: "",
            lastname: "",
            city: "",
            countryCode: "",
            extraproperties: {
                CustomFields: {}
            },
            courses: [],
            selectedCourses: [],
            loading: false,
            lastSelectedCourseId: null,
            studentData: {},
            coursePrice: null,
            items: [],
            custom_extra_properties: {},
            item_group: [],
            selectedItemGroup: null
        };
    },
    computed: {
        ...mapState(['erp_api_url',"authorization_token"]),
    },
    methods: {
        async fetchAllItems(selectedItemGroup) {
            try {
                this.loading = true;
                const response = await fetch(`${this.erp_api_url}api/resource/Item?filters=[["item_group", "=", "${selectedItemGroup}"]]&fields=["*"]`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                });
                const items = await response.json();
                this.items = items.data;
            } catch (error) {
                console.error('Error fetching courses:', error);
            } finally {
                this.loading = false;
            }
        },
        async fetchItemGroups() {
            try {
                const response = await fetch(this.erp_api_url + 'api/resource/Item%20Group', {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                });
                const itemgroups = await response.json();
                this.item_group = itemgroups.data;
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        },
        async handleSubmit(e) {
            e.preventDefault();
            this.loading = true;
            if (this.isPhoneError) {
                this.$toasted.error("Please enter a valid Phone Number", {
                    theme: "outline",
                    duration: 3000,
                    icon: "exclamation-triangle",
                    position: "bottom-center",
                });
                return;
            }
            try {
                // Student create in LMS Level
                const createstudent = {
                    firstName: this.name,
                    lastName: this.lastname,
                    mobile: this.mobile,
                    email: this.email,
                    username: `${this.name}_${this.lastname}`,
                    "password": "!qsf_1234",
                    countryCode: this.countryCode,
                    city: this.city,
                    extraproperties: "{\"CustomFields\":{\"SchoolName\":\"abc\"}}"   
                };
                const userId = await LmsApiHelper.createStudentInLMS(createstudent);
                const createCustomerData = {
                    customer_name: this.email,
                    custom_extra_properties: JSON.stringify({
                        mobile: this.mobile,
                        name: this.name,
                        lastname: this.lastname,
                        city: this.city
                    }),
                    customer_type: "Individual",
                    custom_user_id: userId.payload.id
                };
                const selectedItemIDs = this.selectedCourses.map(item => ({
                    item_code: item.name,
                    amount: 0,
                    rate: 0,
                    qty: 1,
                    custom_product_variant_id: item.custom_product_variant_id
                }));
                console.log(selectedItemIDs);
                const createOpportunityData = {
                    opportunity_from: "Customer",
                    party_name: this.email,
                    items: selectedItemIDs
                };
                console.log({
                    createOpportunityData
                });
                const status = await this.getCustomerByName();
                if (status !== null) {
                    await this.createOpportunity(createOpportunityData);
                } else {
                    await this.createCustomer(createCustomerData);
                    await this.createOpportunity(createOpportunityData);
                }
                this.email = '';
                this.mobile = '';
                this.name = '';
                this.lastname = '';
                this.city = '';
                this.selectedCourses = [];
                this.selectedItemGroup = null;
            } finally {
                const message = "Form Filled Successfully!";
                this.loading = false;
                this.$toasted.success(
                    `${message} !`, {
                        theme: "outline",
                        position: "bottom-center",
                        duration: 3000,
                    }
                );
            }
        },
        async getCustomerByName() {
            try {
                const getCustomerByName = await fetch(`${this.erp_api_url}api/resource/Customer/${this.email}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                });

                if (getCustomerByName.status === 200) {
                    return getCustomerByName.status;
                } else {
                    return null;
                }
            } catch (error) {
                console.error('Error:', error);
                return null;
            }
        },
        async createOpportunity(addOpportunityData) {
            try {
                const createOpportinityResponse = await fetch(this.erp_api_url + 'api/resource/Opportunity', {
                    method: 'POST',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                    body: JSON.stringify(addOpportunityData),
                })
            } catch (error) {
                console.error('Error submitting student form:', error);
            }
        },
        async createCustomer(addCustomerData) {
            try {
                const createCustomerResponse = await fetch(this.erp_api_url + 'api/resource/Customer', {
                    method: 'POST',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                    body: JSON.stringify(addCustomerData),
                });
            } catch (error) {
                console.error('Error submitting student form:', error);
            }
        },
        validate(num, obj) {
            if (obj.valid != null && obj.valid === false) {
                this.isPhoneError = true;
                return;
            }
            this.isPhoneError = false;
            if (obj.country && obj.country.iso2) {
                this.countryCode = getCountryISO3(obj.country.iso2);
                this.phone = obj.number;
            }
            return false;
        },
    },
    mounted() {
        this.fetchItemGroups();
    },
    watch: {
        selectedItemGroup(newValue) {
            if (this.selectedItemGroup) {
                this.fetchAllItems(newValue.name);
            }
        }
    }
}
</script>

<style>
#login-register {
    align-items: center;
    flex-direction: column;
    max-width: 660px;
    margin: auto;
    padding: 60px 7% 0;
}

#submit-button {
    background-color: rgb(224, 16, 36);
    color: white;
    font-weight: bold;
}

.dividend {
    background: #fff;
    box-shadow: 0 0 8px rgba(0, 0, 0, .08);
    border-radius: 6px;
    padding: 1.25rem 1.375rem 1.5rem;
    width: 22.625rem;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border: solid 1px var(--border-color);
}

.course-card {
    margin-bottom: 10px;
}

.cardd {
    position: relative;
    bottom: 458px;
    left: 500px;
}
</style>
